enum PlayerRemoteActionsTypes {
  CLEAN_FILES_CACHE = 'CLEAN_FILES_CACHE',
  CLEAN_FILES_AND_PLAYER_CACHE = 'CLEAN_FILES_AND_PLAYER_CACHE',
  CLEAN_PLAYER_CACHE = 'CLEAN_PLAYER_CACHE'
}
export default PlayerRemoteActionsTypes;
